import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReceiptPDF from '../../Shared/ReceiptPDF';
import { auth } from '../../../services';
import { history } from '../../../helpers/history';

class Payment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {

    }
    routeChange() {
        let path = '/dashboard';
        history.push(path);
      }
    render() {
        return (
          <div className="homeContainer">
              <div className="homeWelcomeContent reset-password">
                <div className="container-fluid">
                  <h1>Purchase Processed Successfully</h1>
                  <p>Thank you for your purchase, your receipt is shown below.</p>
                  {(auth.isAuthenticated())?<button onClick ={this.routeChange} className="btnLink btn btn-sm btnSecondary">Continue to Member Center</button>:""}
                  
                  {this.props.store.transactionId ?
                      <ReceiptPDF
                          pdfData={this.props.store.transactionId}
                      />
                  : ""}
                </div>
              </div>
          </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.store
    }
}

export default withRouter(connect(mapStateToProps, null)(Payment));